import { FallbackErrorBoundary } from "@/components/FallbackErrorBoundary";
import { ListContainer } from "@/components/layout/ListContainer";
import { type DesignsInfo, type NormalizedDrawing } from "@repo/api";
import { T } from "@repo/translation";

import { DesignItem } from "./cards/DesignItem";
import { DrawingItem } from "./cards/DrawingItem";

interface DrawingsProps {
  editable?: boolean;
  drawings?: NormalizedDrawing[];
  onDisassociate?: (drawingId: string) => void;
  drawingInLoading?: string;
  designs?: DesignsInfo[];
}
export const Drawings = ({
  editable,
  drawings,
  onDisassociate,
  drawingInLoading,
  designs,
}: DrawingsProps) => {
  if (
    (!drawings || drawings.length === 0) &&
    (!designs || designs?.length === 0)
  ) {
    return <T translationKey="prompt.no_associated_drawings" />;
  }

  return (
    <ListContainer>
      {drawings?.map((d) => (
        <FallbackErrorBoundary
          errorMessage={`Failed to render drawing: ${d?.id}`}
          key={d.id}
        >
          <DrawingItem
            editable={editable ?? false}
            drawingInfo={d}
            onDisassociate={onDisassociate}
            drawingInLoading={drawingInLoading}
          />
        </FallbackErrorBoundary>
      ))}

      {designs?.map((d) => (
        <FallbackErrorBoundary
          errorMessage={`Failed to render drawing: ${d?.designId}`}
          key={d.designId}
        >
          <DesignItem
            editable={editable ?? false}
            designInfo={d}
            onDisassociate={onDisassociate}
            drawingInLoading={drawingInLoading}
          />
        </FallbackErrorBoundary>
      ))}
    </ListContainer>
  );
};
